// Laadt de Firestore-SDK in de browser pas op het moment dat er echt iets gelezen of geschreven
// wordt, in plaats van statisch in de eerste bundel van elke pagina.
//
// Waarom (MOW-PERF-OKT26, bundelslanking): `firebase/firestore` is ±470 KB geparseerd (+ re2js
// 160 KB) en stond via `import { db } from "@/lib/firebase"` in de eerste JavaScript van élke
// pagina, ook waar bij het laden niets uit Firestore gehaald wordt. Nu is het een eigen chunk die
// alleen wordt opgehaald als iemand `laadFirestore()` aanroept. De aanroep is asynchroon: gebruik
// hem binnen een bestaande async-functie of effect, niet tijdens het renderen.
//
// Alleen de functies die de winkel gebruikt worden doorgegeven, zodat de bundelaar de rest van de
// SDK kan weglaten (een `...fs`-spread zou alles in de chunk houden). Heb je er een nodig die hier
// ontbreekt: voeg hem hieronder toe.
async function laad() {
  const [fs, { db }] = await Promise.all([
    import("firebase/firestore"),
    import("@/lib/firebase-db"),
  ]);
  return {
    db,
    collection: fs.collection,
    doc: fs.doc,
    getDoc: fs.getDoc,
    getDocs: fs.getDocs,
    query: fs.query,
    where: fs.where,
    orderBy: fs.orderBy,
    documentId: fs.documentId,
    addDoc: fs.addDoc,
    setDoc: fs.setDoc,
    serverTimestamp: fs.serverTimestamp,
  };
}

export type FirestoreKit = Awaited<ReturnType<typeof laad>>;

let belofte: Promise<FirestoreKit> | null = null;

/** Eén gedeelde belofte per paginalading; na een mislukte chunk-download mag een volgende aanroep opnieuw proberen. */
export function laadFirestore(): Promise<FirestoreKit> {
  if (!belofte) {
    belofte = laad().catch((err) => {
      belofte = null;
      throw err;
    });
  }
  return belofte;
}
